import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";

import axios from 'axios';
import { init as initAnalytics } from './utils/analyticsService';
import { startMarket, withMarket } from './utils/market';
import { syncSmartBanner } from './utils/appBanner';

// Fetch IP address as early as possible to avoid CORS issues later
// This will execute before React even renders
(function() {
  if (!localStorage.getItem('user_ip_address')) {
    console.log('Fetching IP address on app start...');
    const script = document.createElement('script');
    script.text = `
      fetch('https://api.ipify.org/?format=json')
        .then(response => response.json())
        .then(data => {
          console.log('IP address fetched at app start:', data.ip);
          localStorage.setItem('user_ip_address', data.ip);
        })
        .catch(err => {
          console.error('Error fetching IP address at app start:', err);
        });
    `;
    document.head.appendChild(script);
  } else {
    console.log('IP already in localStorage:', localStorage.getItem('user_ip_address'));
  }
})();

// PostHog + GA4/GTM, production builds only; UTM capture everywhere.
initAnalytics();

// The country store, from what is already known; App settles it after render.
startMarket();
axios.interceptors.request.use(withMarket);

// The iOS Smart App Banner for this store and page, before the document
// finishes loading (Safari reads it then); App keeps it current on navigation.
syncSmartBanner();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);